// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Jax5","bigColWidth":"Table_bigColWidth__1-8oF","biggerColWidth":"Table_biggerColWidth__2L1P3","row":"Table_row__3urfK","col":"Table_col__khW12"};